import {memoize} from 'lodash';

const memoizedPrelSkattTypList = memoize((year) => [
	{value: 'HUV', text: 'Huvudarbetsgivare (enligt skattetabell)'},
	{value: 'EXT', text: 'Sidoinkomster (30%)'},
	{value: 'TMP', text: 'Korttidsarbete mindre än 1 vecka (30%)'},
	{value: 'STU', text: 'Studerande utan skatteavdrag (0%)'},
	{value: 'JUR', text: 'Juridisk person utan F-skatt (30%)'},
	{value: 'FTG', text: 'Uppdragstagare med F-skatt (0%)'},
	{value: 'S25', text: `Utomlands bosatta SINK (${(SkattService.getS25SktPrcByYear(year) * 100).toString().replaceAll('.', ',')}%)`},
	// {value: 'S15', text: 'Utomlands bosatta sjömän SINK (15%)'},
	{value: 'A15', text: 'A-SINK (15%)'},
	{value: 'LOK', text: 'Lokalanställd (0%)'},
	{value: '???', text: 'Okänt skatteförhållande (standardtabell + 10%)'},
	{value: 'NEJ', text: 'Inget skatteavdrag (0%)'},
]);

class SkattService {
	static getPrelSkattTypList(Year) {
		return memoizedPrelSkattTypList(Year);
	}

	static getPrelSkattTypPrcMap(Year) {
		return {
			'EXT': 0.3,
			'TMP': 0.3,
			'STU': 0,
			'JUR': 0.3,
			'FTG': 0,
			'S25': SkattService.getS25SktPrcByYear(Year),
			'S15': 0.15,
			'A15': 0.15,
			'LOK': 0,
			'NEJ': 0,
		};
	}

	static getS25SktPrcByYear(Year) {
		Year = parseInt(Year, 10);

		if(Year >= 2027) {
			return 0.20;
		} else if(Year >= 2026) {
			return 0.225;
		}

		return 0.25;
	}
}

export default SkattService;
